import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent } from "./ui/dialog";
import { Button } from "./ui/button";
import { CircleDot, MonitorPlay, Twitch, Gamepad2, PlayCircle, ChevronRight, Check } from "lucide-react";

const STEPS = [
  { icon: CircleDot, title: "Configura le ruote", text: "Operatori, obiettivi e penitenze sono già precaricati e completamente modificabili da Gestione contenuti.", to: "/content", cta: "Apri Gestione" },
  { icon: MonitorPlay, title: "Configura OBS", text: "Copia l'URL dell'overlay e aggiungilo come Browser Source 1920×1080 in OBS.", to: "/overlay-editor", cta: "Apri Overlay OBS" },
  { icon: Twitch, title: "Collega Twitch (opzionale)", text: "Configura le credenziali per gli abbonati automatici, oppure usa la simulazione per provare subito.", to: "/settings", cta: "Impostazioni Twitch" },
  { icon: Gamepad2, title: "Configura Stream Deck (opzionale)", text: "Genera una API Key e installa il companion plugin per controllare tutto dai tasti fisici.", to: "/stream-deck", cta: "Apri Stream Deck" },
  { icon: PlayCircle, title: "Esegui un test", text: "Vai alla pagina Streaming e prova le ruote, gli obiettivi e la simulazione abbonato.", to: "/streaming", cta: "Vai a Streaming" },
];

export default function OnboardingWizard() {
  const [open, setOpen] = useState(() => !localStorage.getItem("sw_onboarded"));
  const [step, setStep] = useState(0);
  const navigate = useNavigate();

  const finish = () => { localStorage.setItem("sw_onboarded", "1"); setOpen(false); };
  const s = STEPS[step];
  const Icon = s.icon;

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) finish(); }}>
      <DialogContent className="bg-[#11141d] border-[#334155] text-white max-w-lg" data-testid="onboarding-dialog">
        <div className="flex items-center gap-2 mb-1">
          {STEPS.map((_, i) => (
            <div key={i} className={`h-1.5 flex-1 rounded-full ${i <= step ? "bg-amber-500" : "bg-[#334155]"}`} />
          ))}
        </div>
        <div className="text-xs text-amber-500 uppercase tracking-widest font-semibold">Passo {step + 1} di {STEPS.length}</div>
        <div className="flex items-start gap-4 mt-2">
          <div className="w-12 h-12 rounded-lg bg-amber-500/15 border border-amber-500/40 flex items-center justify-center shrink-0">
            <Icon className="w-6 h-6 text-amber-400" />
          </div>
          <div>
            <h2 className="font-display text-2xl font-extrabold uppercase text-white leading-tight">{s.title}</h2>
            <p className="text-slate-300 text-sm mt-2">{s.text}</p>
            <Button variant="link" className="text-amber-400 px-0 h-auto mt-1" onClick={() => { navigate(s.to); finish(); }} data-testid="onboarding-cta">
              {s.cta} <ChevronRight className="w-4 h-4 ml-1" />
            </Button>
          </div>
        </div>
        <div className="flex justify-between items-center mt-4">
          <Button variant="ghost" className="text-slate-400" onClick={finish} data-testid="onboarding-skip">Salta</Button>
          {step < STEPS.length - 1 ? (
            <Button className="bg-amber-500 hover:bg-amber-400 text-[#080a0f]" onClick={() => setStep(step + 1)} data-testid="onboarding-next">
              Avanti <ChevronRight className="w-4 h-4 ml-1" />
            </Button>
          ) : (
            <Button className="bg-emerald-600 hover:bg-emerald-500 text-white" onClick={finish} data-testid="onboarding-finish">
              <Check className="w-4 h-4 mr-1" /> Inizia
            </Button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
